import { render } from "./PhotographyView.vue?vue&type=template&id=57e335a4&ts=true"
import script from "./PhotographyView.vue?vue&type=script&lang=ts"
export * from "./PhotographyView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__